export enum EGaEvents {
	CLICK_CATEGORY = 'click_category',
	CLICK_GEO = 'click_geo',
	CLICK_CAP = 'click_cap',
	CLICK_CREATE_SOURCE = 'click_create_source',
	CLICK_FILTERS_BUTTON = 'click_filters_button',
	CLICK_SPECIFY_SOURCES = 'click_specify_sources',
	CLICK_JOIN = 'click_join',
	CLICK_LOGO = 'click_logo',
	CLICK_NOTIFICATION = 'click_notifications',
	CLICK_USER_ICON = 'click_user_icon',
	CLICK_FAQS = 'click_faqs',
	CLICK_PRIVACY_POLICY = 'click_privacy_policy',
	CLICK_SUPPORT = 'click_support',
	CLICK_TERMS_OF_USE = 'click_terms_of_use',
	CLICK_SELECT_LANGUAGE = 'click_select_language',
	CLICK_SOCIALS = 'click_social',
	CLICK_HELP_CENTER = 'click_help_center',
	CLICK_DASHBOARD = 'click_dashboard',
	CLICK_CATALOG = 'click_catalog',
	CLICK_MY_OFFERS = 'click_my_offers',
	CLICK_MY_SOURCES = 'click_my_sources',
	CLICK_MY_FINANCES = 'click_my_finances',
	CLICK_MY_REPORTS = 'click_my_reports',
	CLICK_LOGOUT = 'click_logout',
	CLICK_LETS_BEGIN = 'click_lets_begin',
	CLICK_NEXT = 'click_next',
	CLICK_BACK = 'click_back',
	CLICK_CURRENCY = 'click_currency',
	CLICK_SOURCE_ID = 'click_source_id',
	CLICK_SOURCE_NAME = 'click_source_name',
	CHECKBOX_PRIVACY = 'checkbox_privacy',
	SEND_JOIN_PROGRAM = 'send_join_program_success',
	SEND_CREATE_ADSPACE_SOURCE = 'send_create_adspace_success',
	SEND_SAVE_ADSPACE_SOURCE = 'send_save_adspace_success',
	SEARCH_SEARCH_BRANDS = 'search_search_brands',
}
